export enum EntityStoreKey {
  Positions = 'positions',
}
